const COUNTRY_CODE_REGEX = /\(([A-Z]{2})\)\.svg$/

export const flagPathByCountryCode: Record<string, string> = {}

export const prefixes = [
    {
        prefix: '+47',
        code: '/assets/img/flags_rounded/Rounded=Norway (NO).svg',
    },
    { prefix: '+966', code: '/assets/img/flags_rounded/Saudi Arabia.svg' },
    {
        prefix: '+30',
        code: '/assets/img/flags_rounded/Rounded=Greece (GR).svg',
    },
    {
        prefix: '+263',
        code: '/assets/img/flags_rounded/Rounded=Zimbabwe (ZW).svg',
    },
    {
        prefix: '+260',
        code: '/assets/img/flags_rounded/Rounded=Zambia (ZM).svg',
    },
    {
        prefix: '+967',
        code: '/assets/img/flags_rounded/Rounded=Yemen (YE).svg',
    },
    {
        prefix: '+681',
        code: '/assets/img/flags_rounded/Rounded=Wallis and Futuna (WF).svg',
    },
    {
        prefix: '+284',
        code: '/assets/img/flags_rounded/Rounded=Virgin Islands (U.S.) (VI).svg',
    },
    {
        prefix: '+84',
        code: '/assets/img/flags_rounded/Rounded=Vietnam (VN).svg',
    },
    {
        prefix: '+58',
        code: '/assets/img/flags_rounded/Rounded=Venezuela (Bolivarian Republic of) (VE).svg',
    },
    {
        prefix: '+678',
        code: '/assets/img/flags_rounded/Rounded=Vanuatu (VU).svg',
    },
    {
        prefix: '+998',
        code: '/assets/img/flags_rounded/Rounded=Uzbekistan (UZ).svg',
    },
    {
        prefix: '+598',
        code: '/assets/img/flags_rounded/Rounded=Uruguay (UY).svg',
    },
    {
        prefix: '+1',
        code: '/assets/img/flags_rounded/Rounded=United States of America (US).svg',
    },
    {
        prefix: '+44',
        code: '/assets/img/flags_rounded/Rounded=United Kingdom (GB).svg',
    },
    {
        prefix: '+971',
        code: '/assets/img/flags_rounded/Rounded=United Arab Emirates (AE).svg',
    },
    {
        prefix: '+380',
        code: '/assets/img/flags_rounded/Rounded=Ukraine (UA).svg',
    },
    {
        prefix: '+256',
        code: '/assets/img/flags_rounded/Rounded=Uganda (UG).svg',
    },
    {
        prefix: '+688',
        code: '/assets/img/flags_rounded/Rounded=Tuvalu (TV).svg',
    },
    {
        prefix: '+649',
        code: '/assets/img/flags_rounded/Rounded=Turks and Caicos Islands (TC).svg',
    },
    {
        prefix: '+993',
        code: '/assets/img/flags_rounded/Rounded=Turkmenistan (TM).svg',
    },
    {
        prefix: '+90',
        code: '/assets/img/flags_rounded/Rounded=Turkey (TR).svg',
    },
    {
        prefix: '+216',
        code: '/assets/img/flags_rounded/Rounded=Tunisia (TN).svg',
    },
    {
        prefix: '+868',
        code: '/assets/img/flags_rounded/Rounded=Trinidad and Tobago (TT).svg',
    },
    {
        prefix: '+676',
        code: '/assets/img/flags_rounded/Rounded=Tonga (TO).svg',
    },
    {
        prefix: '+228',
        code: '/assets/img/flags_rounded/Rounded=Togo (TG).svg',
    },
    {
        prefix: '+670',
        code: '/assets/img/flags_rounded/Rounded=Timor-Leste (TL).svg',
    },
    {
        prefix: '+220',
        code: '/assets/img/flags_rounded/Rounded=Gambia (GM).svg',
    },
    {
        prefix: '+242',
        code: '/assets/img/flags_rounded/Rounded=Bahamas (BS).svg',
    },
    {
        prefix: '+66',
        code: '/assets/img/flags_rounded/Rounded=Thailand (TH).svg',
    },
    {
        prefix: '+255',
        code: '/assets/img/flags_rounded/Rounded=Tanzania (TZ).svg',
    },
    {
        prefix: '+992',
        code: '/assets/img/flags_rounded/Rounded=Tajikistan (TJ).svg',
    },
    {
        prefix: '+886',
        code: '/assets/img/flags_rounded/Rounded=Taiwan (TW).svg',
    },
    {
        prefix: '+963',
        code: '/assets/img/flags_rounded/Rounded=Syrian Arab Republic (SY).svg',
    },
    {
        prefix: '+41',
        code: '/assets/img/flags_rounded/Rounded=Switzerland (CH).svg',
    },
    {
        prefix: '+46',
        code: '/assets/img/flags_rounded/Rounded=Sweden (SE).svg',
    },
    {
        prefix: '+268',
        code: '/assets/img/flags_rounded/Rounded=Switzerland (CH).svg',
    },
    {
        prefix: '+597',
        code: '/assets/img/flags_rounded/Rounded=Suriname (SR).svg',
    },
    {
        prefix: '+249',
        code: '/assets/img/flags_rounded/Rounded=Sudan (SD).svg',
    },
    {
        prefix: '+211',
        code: '/assets/img/flags_rounded/Rounded=South Sudan (SS).svg',
    },
    {
        prefix: '+94',
        code: '/assets/img/flags_rounded/Rounded=Sri Lanka (LK).svg',
    },
    {
        prefix: '+34',
        code: '/assets/img/flags_rounded/Rounded=Spain (ES).svg',
    },
    {
        prefix: '+82',
        code: '/assets/img/flags_rounded/Rounded=South Korea (KR).svg',
    },
    {
        prefix: '+27',
        code: '/assets/img/flags_rounded/Rounded=South Africa (ZA).svg',
    },
    {
        prefix: '+252',
        code: '/assets/img/flags_rounded/Rounded=Somalia (SO).svg',
    },
    {
        prefix: '+677',
        code: '/assets/img/flags_rounded/Rounded=Solomon Islands (SB).svg',
    },
    {
        prefix: '+386',
        code: '/assets/img/flags_rounded/Rounded=Slovenia (SI).svg',
    },
    {
        prefix: '+421',
        code: '/assets/img/flags_rounded/Rounded=Slovakia (SK).svg',
    },
    {
        prefix: '+65',
        code: '/assets/img/flags_rounded/Rounded=Singapore (SG).svg',
    },
    {
        prefix: '+232',
        code: '/assets/img/flags_rounded/Rounded=Sierra Leone (SL).svg',
    },
    {
        prefix: '+248',
        code: '/assets/img/flags_rounded/Rounded=Seychelles (SC).svg',
    },
    {
        prefix: '+381',
        code: '/assets/img/flags_rounded/Rounded=Serbia (RS).svg',
    },
    {
        prefix: '+221',
        code: '/assets/img/flags_rounded/Rounded=Senegal (SN).svg',
    },
    {
        prefix: '+996',
        code: '/assets/img/flags_rounded/Rounded=Saudi Arabia (SA).svg',
    },
    {
        prefix: '+239',
        code: '/assets/img/flags_rounded/Rounded=Sao Tome and Principe (ST).svg',
    },
    {
        prefix: '+378',
        code: '/assets/img/flags_rounded/Rounded=San Marino (SM).svg',
    },
    {
        prefix: '+685',
        code: '/assets/img/flags_rounded/Rounded=Samoa (WS).svg',
    },
    {
        prefix: '+784',
        code: '/assets/img/flags_rounded/Rounded=Saint Vincent and the Grenadines (VC).svg',
    },
    {
        prefix: '+508',
        code: '/assets/img/flags_rounded/Rounded=Saint Pierre and Miquelon (PM).svg',
    },
    {
        prefix: '+758',
        code: '/assets/img/flags_rounded/Rounded=Saint Lucia (LC).svg',
    },
    {
        prefix: '+869',
        code: '/assets/img/flags_rounded/Rounded=Saint Kitts and Nevis (KN).svg',
    },
    {
        prefix: '+290',
        code: '/assets/img/flags_rounded/Rounded=Saint Helena Ascension and Tristan da Cunha (SH).svg',
    },
    {
        prefix: '+250',
        code: '/assets/img/flags_rounded/Rounded=Rwanda (RW).svg',
    },
    {
        prefix: '+7',
        code: '/assets/img/flags_rounded/Rounded=Russia (RU).svg',
    },
    {
        prefix: '+40',
        code: '/assets/img/flags_rounded/Rounded=Romania (RO).svg',
    },
    {
        prefix: '+242',
        code: '/assets/img/flags_rounded/Rounded=Republic of the Congo (CG).svg',
    },
    {
        prefix: '+974',
        code: '/assets/img/flags_rounded/Rounded=Qatar (QA).svg',
    },
    {
        prefix: '+351',
        code: '/assets/img/flags_rounded/Rounded=Portugal (PT).svg',
    },
    {
        prefix: '+48',
        code: '/assets/img/flags_rounded/Rounded=Poland (PL).svg',
    },
    {
        prefix: '+63',
        code: '/assets/img/flags_rounded/Rounded=Philippines (PH).svg',
    },
    {
        prefix: '+51',
        code: '/assets/img/flags_rounded/Rounded=Peru (PE).svg',
    },
    {
        prefix: '+595',
        code: '/assets/img/flags_rounded/Rounded=Paraguay (PY).svg',
    },
    {
        prefix: '+675',
        code: '/assets/img/flags_rounded/Rounded=Papua New Guinea (PG).svg',
    },
    {
        prefix: '+507',
        code: '/assets/img/flags_rounded/Rounded=Panama (PA).svg',
    },
    {
        prefix: '+970',
        code: '/assets/img/flags_rounded/Rounded=State of Palestine (PS).svg',
    },
    {
        prefix: '+680',
        code: '/assets/img/flags_rounded/Rounded=Palau (PW).svg',
    },
    {
        prefix: '+92',
        code: '/assets/img/flags_rounded/Rounded=Pakistan (PK).svg',
    },
    {
        prefix: '+968',
        code: '/assets/img/flags_rounded/Rounded=Oman (OM).svg',
    },
    {
        prefix: '+850',
        code: '/assets/img/flags_rounded/Rounded=North Korea (KP).svg',
    },
    {
        prefix: '+852',
        code: '/assets/img/flags_rounded/Rounded=Hong Kong (HK).svg',
    },
    {
        prefix: '+683',
        code: '/assets/img/flags_rounded/Rounded=Niue (NU).svg',
    },
    {
        prefix: '+234',
        code: '/assets/img/flags_rounded/Rounded=Nigeria (NG).svg',
    },
    {
        prefix: '+227',
        code: '/assets/img/flags_rounded/Rounded=Niger (NE).svg',
    },
    {
        prefix: '+505',
        code: '/assets/img/flags_rounded/Rounded=Nicaragua (NI).svg',
    },
    {
        prefix: '+64',
        code: '/assets/img/flags_rounded/Rounded=New Zealand (NZ).svg',
    },
    {
        prefix: '+31',
        code: '/assets/img/flags_rounded/Rounded=Netherlands (NL).svg',
    },
    {
        prefix: '+599',
        code: '/assets/img/flags_rounded/Rounded=Curac\u0327ao (CW).svg',
    },
    {
        prefix: '+977',
        code: '/assets/img/flags_rounded/Rounded=Nepal (NP).svg',
    },
    {
        prefix: '+674',
        code: '/assets/img/flags_rounded/Rounded=Nauru (NR).svg',
    },
    {
        prefix: '+264',
        code: '/assets/img/flags_rounded/Rounded=Namibia (NA).svg',
    },
    {
        prefix: '+258',
        code: '/assets/img/flags_rounded/Rounded=Mozambique (MZ).svg',
    },
    {
        prefix: '+212',
        code: '/assets/img/flags_rounded/Rounded=Morocco (MA).svg',
    },
    {
        prefix: '+1664',
        code: '/assets/img/flags_rounded/Rounded=Montserrat (MS).svg',
    },
    {
        prefix: '+382',
        code: '/assets/img/flags_rounded/Rounded=Montenegro (ME).svg',
    },
    {
        prefix: '+976',
        code: '/assets/img/flags_rounded/Rounded=Mongolia (MN).svg',
    },
    {
        prefix: '+377',
        code: '/assets/img/flags_rounded/Rounded=Monaco (MC).svg',
    },
    {
        prefix: '+373',
        code: '/assets/img/flags_rounded/Rounded=Moldova (MD).svg',
    },
    {
        prefix: '+691',
        code: '/assets/img/flags_rounded/Rounded=Federated States of Micronesia (FM).svg',
    },
    {
        prefix: '+52',
        code: '/assets/img/flags_rounded/Rounded=Mexico (MX).svg',
    },
    {
        prefix: '+262',
        code: '/assets/img/flags_rounded/Rounded=Mayotte (YT).svg',
    },
    {
        prefix: '+230',
        code: '/assets/img/flags_rounded/Rounded=Mauritius (MU).svg',
    },
    {
        prefix: '+222',
        code: '/assets/img/flags_rounded/Rounded=Mauritania (MR).svg',
    },
    {
        prefix: '+692',
        code: '/assets/img/flags_rounded/Rounded=Marshall Islands (MH).svg',
    },
    {
        prefix: '+356',
        code: '/assets/img/flags_rounded/Rounded=Malta (MT).svg',
    },
    {
        prefix: '+223',
        code: '/assets/img/flags_rounded/Rounded=Mali (ML).svg',
    },
    {
        prefix: '+960',
        code: '/assets/img/flags_rounded/Rounded=Maldives (MV).svg',
    },
    {
        prefix: '+60',
        code: '/assets/img/flags_rounded/Rounded=Malaysia (MY).svg',
    },
    {
        prefix: '+265',
        code: '/assets/img/flags_rounded/Rounded=Malawi (MW).svg',
    },
    {
        prefix: '+261',
        code: '/assets/img/flags_rounded/Rounded=Madagascar (MG).svg',
    },
    {
        prefix: '+389',
        code: '/assets/img/flags_rounded/Rounded=North Macedonia (MK).svg',
    },
    {
        prefix: '+352',
        code: '/assets/img/flags_rounded/Rounded=Luxembourg (LU).svg',
    },
    {
        prefix: '+370',
        code: '/assets/img/flags_rounded/Rounded=Lithuania (LT).svg',
    },
    {
        prefix: '+423',
        code: '/assets/img/flags_rounded/Rounded=Liechtenstein (LI).svg',
    },
    {
        prefix: '+218',
        code: '/assets/img/flags_rounded/Rounded=Libya (LY).svg',
    },
    {
        prefix: '+231',
        code: '/assets/img/flags_rounded/Rounded=Liberia (LR).svg',
    },
    {
        prefix: '+266',
        code: '/assets/img/flags_rounded/Rounded=Lesotho (LS).svg',
    },
    {
        prefix: '+961',
        code: '/assets/img/flags_rounded/Rounded=Lebanon (LB).svg',
    },
    {
        prefix: '+371',
        code: '/assets/img/flags_rounded/Rounded=Latvia (LV).svg',
    },
    {
        prefix: '+856',
        code: '/assets/img/flags_rounded/Rounded=Laos (LA).svg',
    },
    {
        prefix: '+996',
        code: '/assets/img/flags_rounded/Rounded=Kyrgyzstan (KG).svg',
    },
    {
        prefix: '+985',
        code: '/assets/img/flags_rounded/Rounded=Kuwait (KW).svg',
    },
    {
        prefix: '+686',
        code: '/assets/img/flags_rounded/Rounded=Kiribati (KI).svg',
    },
    {
        prefix: '+254',
        code: '/assets/img/flags_rounded/Rounded=Kenya (KE).svg',
    },
    {
        prefix: '+997',
        code: '/assets/img/flags_rounded/Rounded=Kazakhstan (KZ).svg',
    },
    {
        prefix: '+962',
        code: '/assets/img/flags_rounded/Rounded=Jordan (JO).svg',
    },
    {
        prefix: '+876',
        code: '/assets/img/flags_rounded/Rounded=Jamaica (JM).svg',
    },
    {
        prefix: '+39',
        code: '/assets/img/flags_rounded/Rounded=Italy (IT).svg',
    },
    {
        prefix: '+972',
        code: '/assets/img/flags_rounded/Rounded=Israel (IL).svg',
    },
    {
        prefix: '+353',
        code: '/assets/img/flags_rounded/Rounded=Ireland (IE).svg',
    },
    {
        prefix: '+964',
        code: '/assets/img/flags_rounded/Rounded=Iraq (IQ).svg',
    },
    {
        prefix: '+98',
        code: '/assets/img/flags_rounded/Rounded=Iran (Islamic Republic of) (IR).svg',
    },
    {
        prefix: '+62',
        code: '/assets/img/flags_rounded/Rounded=Indonesia (ID).svg',
    },
    {
        prefix: '+91',
        code: '/assets/img/flags_rounded/Rounded=India (IN).svg',
    },
    {
        prefix: '+354',
        code: '/assets/img/flags_rounded/Rounded=Iceland (IS).svg',
    },
    {
        prefix: '+36',
        code: '/assets/img/flags_rounded/Rounded=Hungary (HU).svg',
    },
    {
        prefix: '+509',
        code: '/assets/img/flags_rounded/Rounded=Haiti (HT).svg',
    },
    {
        prefix: '+592',
        code: '/assets/img/flags_rounded/Rounded=Guyana (GY).svg',
    },
    {
        prefix: '+245',
        code: '/assets/img/flags_rounded/Rounded=Guinea-Bissau (GW).svg',
    },
    {
        prefix: '+224',
        code: '/assets/img/flags_rounded/Rounded=Guinea (GN).svg',
    },
    {
        prefix: '+502',
        code: '/assets/img/flags_rounded/Rounded=Guatemala (GT).svg',
    },
    {
        prefix: '+590',
        code: '/assets/img/flags_rounded/Rounded=France (FR).svg',
    },
    {
        prefix: '+473',
        code: '/assets/img/flags_rounded/Rounded=Grenada (GD).svg',
    },
    {
        prefix: '+299',
        code: '/assets/img/flags_rounded/Rounded=Greenland (GL).svg',
    },
    {
        prefix: '+350',
        code: '/assets/img/flags_rounded/Rounded=Gibraltar (GI).svg',
    },
    {
        prefix: '+233',
        code: '/assets/img/flags_rounded/Rounded=Ghana (GH).svg',
    },
    {
        prefix: '+49',
        code: '/assets/img/flags_rounded/Rounded=Germany (DE).svg',
    },
    {
        prefix: '+995',
        code: '/assets/img/flags_rounded/Rounded=Georgia (GE).svg',
    },
    {
        prefix: '+241',
        code: '/assets/img/flags_rounded/Rounded=Gabon (GA).svg',
    },
    {
        prefix: '+689',
        code: '/assets/img/flags_rounded/Rounded=French Polynesia (PF).svg',
    },
    {
        prefix: '+33',
        code: '/assets/img/flags_rounded/Rounded=France (FR).svg',
    },
    {
        prefix: '+358',
        code: '/assets/img/flags_rounded/Rounded=Finland (FI).svg',
    },
    {
        prefix: '+679',
        code: '/assets/img/flags_rounded/Rounded=Fiji (FJ).svg',
    },
    {
        prefix: '+298',
        code: '/assets/img/flags_rounded/Rounded=Faroe Islands (FO).svg',
    },
    {
        prefix: '+500',
        code: '/assets/img/flags_rounded/Rounded=Falkland Islands (FK).svg',
    },
    {
        prefix: '+251',
        code: '/assets/img/flags_rounded/Rounded=Ethiopia (ET).svg',
    },
    {
        prefix: '+372',
        code: '/assets/img/flags_rounded/Rounded=Estonia (EE).svg',
    },
    {
        prefix: '+291',
        code: '/assets/img/flags_rounded/Rounded=Eritrea (ER).svg',
    },
    {
        prefix: '+240',
        code: '/assets/img/flags_rounded/Rounded=Equatorial Guinea (GQ).svg',
    },
    {
        prefix: '+503',
        code: '/assets/img/flags_rounded/Rounded=El Salvador (SV).svg',
    },
    {
        prefix: '+20',
        code: '/assets/img/flags_rounded/Rounded=Egypt (EG).svg',
    },
    {
        prefix: '+593',
        code: '/assets/img/flags_rounded/Rounded=Ecuador (EC).svg',
    },
    {
        prefix: '+809',
        code: '/assets/img/flags_rounded/Rounded=Dominican Republic (DO).svg',
    },
    {
        prefix: '+829',
        code: '/assets/img/flags_rounded/Rounded=Dominican Republic (DO).svg',
    },
    {
        prefix: '+849',
        code: '/assets/img/flags_rounded/Rounded=Dominican Republic (DO).svg',
    },
    {
        prefix: '+767',
        code: '/assets/img/flags_rounded/Rounded=Dominica (DM).svg',
    },
    {
        prefix: '+253',
        code: '/assets/img/flags_rounded/Rounded=Djibouti (DJ).svg',
    },
    {
        prefix: '+45',
        code: '/assets/img/flags_rounded/Rounded=Denmark (DK).svg',
    },
    {
        prefix: '+420',
        code: '/assets/img/flags_rounded/Rounded=Czech Republic (CZ).svg',
    },
    {
        prefix: '+357',
        code: '/assets/img/flags_rounded/Rounded=Cyprus (CY).svg',
    },
    {
        prefix: '+53',
        code: '/assets/img/flags_rounded/Rounded=Cuba (CU).svg',
    },
    {
        prefix: '+385',
        code: '/assets/img/flags_rounded/Rounded=Croatia (HR).svg',
    },
    {
        prefix: '+506',
        code: '/assets/img/flags_rounded/Rounded=Costa Rica (CR).svg',
    },
    {
        prefix: '+269',
        code: '/assets/img/flags_rounded/Rounded=Comoros (KM).svg',
    },
    {
        prefix: '+57',
        code: '/assets/img/flags_rounded/Rounded=Colombia (CO).svg',
    },
    {
        prefix: '+86',
        code: '/assets/img/flags_rounded/Rounded=China (CN).svg',
    },
    {
        prefix: '+56',
        code: '/assets/img/flags_rounded/Rounded=Chile (CL).svg',
    },
    {
        prefix: '+235',
        code: '/assets/img/flags_rounded/Rounded=Chad (TD).svg',
    },
    {
        prefix: '+236',
        code: '/assets/img/flags_rounded/Rounded=Central African Republic (CF).svg',
    },
    {
        prefix: '+345',
        code: '/assets/img/flags_rounded/Rounded=Cayman Islands (KY).svg',
    },
    {
        prefix: '+238',
        code: '/assets/img/flags_rounded/Rounded=Cabo Verde (CV).svg',
    },
    {
        prefix: '+237',
        code: '/assets/img/flags_rounded/Rounded=Cameroon (CM).svg',
    },
    {
        prefix: '+855',
        code: '/assets/img/flags_rounded/Rounded=Cambodia (KH).svg',
    },
    {
        prefix: '+257',
        code: '/assets/img/flags_rounded/Rounded=Burundi (BI).svg',
    },
    {
        prefix: '+95',
        code: '/assets/img/flags_rounded/Rounded=Myanmar (MM).svg',
    },
    {
        prefix: '+226',
        code: '/assets/img/flags_rounded/Rounded=Burkina Faso (BF).svg',
    },
    {
        prefix: '+359',
        code: '/assets/img/flags_rounded/Rounded=Bulgaria (BG).svg',
    },
    {
        prefix: '+673',
        code: '/assets/img/flags_rounded/Rounded=Brunei Darussalam (BN).svg',
    },
    {
        prefix: '+284',
        code: '/assets/img/flags_rounded/Rounded=Virgin Islands (British) (VG).svg',
    },
    {
        prefix: '+55',
        code: '/assets/img/flags_rounded/Rounded=Brazil (BR).svg',
    },
    {
        prefix: '+267',
        code: '/assets/img/flags_rounded/Rounded=Botswana (BW).svg',
    },
    {
        prefix: '+387',
        code: '/assets/img/flags_rounded/Rounded=Bosnia and Herzegovina (BA).svg',
    },
    {
        prefix: '+591',
        code: '/assets/img/flags_rounded/Rounded=Bolivia (Plurinational State of) (BO).svg',
    },
    {
        prefix: '+975',
        code: '/assets/img/flags_rounded/Rounded=Bhutan (BT).svg',
    },
    {
        prefix: '+411',
        code: '/assets/img/flags_rounded/Rounded=Bermuda (BM).svg',
    },
    {
        prefix: '+229',
        code: '/assets/img/flags_rounded/Rounded=Benin (BJ).svg',
    },
    {
        prefix: '+501',
        code: '/assets/img/flags_rounded/Rounded=Belize (BZ).svg',
    },
    {
        prefix: '+32',
        code: '/assets/img/flags_rounded/Rounded=Belgium (BE).svg',
    },
    {
        prefix: '+375',
        code: '/assets/img/flags_rounded/Rounded=Belarus (BY).svg',
    },
    {
        prefix: '+246',
        code: '/assets/img/flags_rounded/Rounded=Barbados (BB).svg',
    },
    {
        prefix: '+880',
        code: '/assets/img/flags_rounded/Rounded=Bangladesh (BD).svg',
    },
    {
        prefix: '+973',
        code: '/assets/img/flags_rounded/Rounded=Bahrain (BH).svg',
    },
    {
        prefix: '+994',
        code: '/assets/img/flags_rounded/Rounded=Azerbaijan (AZ).svg',
    },
    {
        prefix: '+43',
        code: '/assets/img/flags_rounded/Rounded=Austria (AT).svg',
    },
    {
        prefix: '+61',
        code: '/assets/img/flags_rounded/Rounded=Australia (AU).svg',
    },
    {
        prefix: '+297',
        code: '/assets/img/flags_rounded/Rounded=Aruba (AW).svg',
    },
    {
        prefix: '+374',
        code: '/assets/img/flags_rounded/Rounded=Armenia (AM).svg',
    },
    {
        prefix: '+54',
        code: '/assets/img/flags_rounded/Rounded=Argentina (AR).svg',
    },
    {
        prefix: '+264',
        code: '/assets/img/flags_rounded/Rounded=Anguilla (AI).svg',
    },
    {
        prefix: '+244',
        code: '/assets/img/flags_rounded/Rounded=Angola (AO).svg',
    },
    {
        prefix: '+376',
        code: '/assets/img/flags_rounded/Rounded=Andorra (AD).svg',
    },
    {
        prefix: '+213',
        code: '/assets/img/flags_rounded/Rounded=Algeria (DZ).svg',
    },
    {
        prefix: '+93',
        code: '/assets/img/flags_rounded/Rounded=Afghanistan (AF).svg',
    },
    {
        prefix: '+355',
        code: '/assets/img/flags_rounded/Rounded=Albania (AL).svg',
    },
    {
        prefix: '+81',
        code: '/assets/img/flags_rounded/Rounded=Japan (JP).svg',
    },
    {
        prefix: '+1340',
        code: '/assets/img/flags_rounded/Rounded=Virgin Islands (U.S.) (VI).svg',
    },
    {
        prefix: '+1284',
        code: '/assets/img/flags_rounded/Rounded=Virgin Islands (British) (VG).svg',
    },
    {
        prefix: '+1784',
        code: '/assets/img/flags_rounded/Rounded=Saint Vincent and the Grenadines (VC).svg',
    },
    {
        prefix: '+1868',
        code: '/assets/img/flags_rounded/Rounded=Trinidad and Tobago (TT).svg',
    },
    {
        prefix: '+1648',
        code: '/assets/img/flags_rounded/Rounded=Turks and Caicos Islands (TC).svg',
    },
    {
        prefix: '+1787',
        code: '/assets/img/flags_rounded/Rounded=Puerto Rico (PR).svg',
    },
    {
        prefix: '+1670',
        code: '/assets/img/flags_rounded/Rounded=Northern Mariana Islands (MP).svg',
    },
    {
        prefix: '+1758',
        code: '/assets/img/flags_rounded/Rounded=Saint Lucia (LC).svg',
    },
    {
        prefix: '+1345',
        code: '/assets/img/flags_rounded/Rounded=Cayman Islands (KY).svg',
    },
    {
        prefix: '+1869',
        code: '/assets/img/flags_rounded/Rounded=Saint Kitts and Nevis (KN).svg',
    },
    {
        prefix: '+1876',
        code: '/assets/img/flags_rounded/Rounded=Jamaica (JM).svg',
    },
    {
        prefix: '+1671',
        code: '/assets/img/flags_rounded/Rounded=Guam (GU).svg',
    },
    {
        prefix: '+1473',
        code: '/assets/img/flags_rounded/Rounded=Grenada (GD).svg',
    },
    {
        prefix: '+1809',
        code: '/assets/img/flags_rounded/Rounded=Dominican Republic (DO).svg',
    },
    {
        prefix: '+1767',
        code: '/assets/img/flags_rounded/Rounded=Dominica (DM).svg',
    },
    {
        prefix: '+1242',
        code: '/assets/img/flags_rounded/Rounded=Bahamas (BS).svg',
    },
    {
        prefix: '+1441',
        code: '/assets/img/flags_rounded/Rounded=Bermuda (BM).svg',
    },
    {
        prefix: '+1246',
        code: '/assets/img/flags_rounded/Rounded=Barbados (BB).svg',
    },
    {
        prefix: '+1684',
        code: '/assets/img/flags_rounded/Rounded=American Samoa (AS).svg',
    },
    {
        prefix: '+1264',
        code: '/assets/img/flags_rounded/Rounded=Anguilla (AI).svg',
    },
    {
        prefix: '+1268',
        code: '/assets/img/flags_rounded/Rounded=Antigua and Barbuda (AG).svg',
    },
]

prefixes.forEach((item) => {
    const match = item.code.match(COUNTRY_CODE_REGEX)
    if (match && !flagPathByCountryCode[match[1]]) {
        flagPathByCountryCode[match[1]] = item.code
    }
})

export const getFlagPathByCountryCode = (code: string): string | undefined => flagPathByCountryCode[code]
